import React from 'react';
import { Link } from 'react-router-dom';
import * as LucideIcons from 'lucide-react';
import Section from '../ui/Section';
import { services } from '../../data/services';

const FeaturedServices: React.FC = () => {
  // Get just 3 services for the homepage feature
  const featuredServices = services.slice(0, 3);
  
  return (
    <Section className="bg-gradient-to-b from-background via-neutral-900/50 to-background">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">Our Services</h2>
        <p className="text-lg text-neutral-300 max-w-2xl mx-auto">
          We provide end-to-end guidance for your AI journey, from strategy to implementation.
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {featuredServices.map((service) => {
          const IconComponent = (LucideIcons as any)[service.icon.charAt(0).toUpperCase() + service.icon.slice(1)];
          
          return (
            <div key={service.id} className="card card-hover p-8 flex flex-col h-full group">
              <div className="h-12 w-12 bg-primary/10 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                {IconComponent && <IconComponent size={24} className="text-primary" />}
              </div>
              <h3 className="text-xl font-semibold mb-3">{service.title}</h3>
              <p className="text-neutral-300">{service.description}</p>
            </div>
          );
        })}
      </div>
      
      <div className="text-center mt-12">
        <Link 
          to="/services" 
          className="inline-flex items-center px-8 py-4 rounded-xl font-medium text-lg bg-gradient-to-r from-primary to-accent hover:from-accent hover:to-primary transition-all duration-500 text-background transform hover:scale-105"
        >
          Learn About Our Approach
          <LucideIcons.ArrowRight size={16} className="ml-2" />
        </Link>
      </div>
    </Section>
  );
};

export default FeaturedServices;